// İSG uzmanı portalı — Firma Onay-Routing (belge türü → departman) TanStack Query anahtarları
// (api-contract §31.2, tenant-scoped). Liste parametreleri (`entity` filtresi + sayfa) içerir;
// invalidasyon önek (`['permit-approval-routing']`) ile. Belge türü seçenekleri ve etiketleri §27
// kaydındandır (`documentTypesKey`, platform verisi — bu ağaçta değil). Ekran `permit-types`
// grant'ı altında olsa da bu veri ayrı bir kaynaktır (routing) — kendi anahtar ağacını tutar.

import type { PermitApprovalRoutingListParams } from '@isgportal/shared';

export const permitApprovalRoutingKeys = {
  /** Tüm routing sorgularının kök öneki — invalidasyon için. */
  all: () => ['permit-approval-routing'] as const,
  /** Tüm liste sorgularının öneki (filtre/sayfa varyantlarını kapsar). */
  list: () => ['permit-approval-routing', 'list'] as const,
  /** Sayfalı + filtreli liste — parametreli. */
  listParams: (params: PermitApprovalRoutingListParams) =>
    ['permit-approval-routing', 'list', params] as const,
} as const;
